import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TpMergeTagChipsComponent } from './tp-merge-tag-chips.component';

@NgModule({
    declarations: [TpMergeTagChipsComponent],
    imports: [CommonModule, MatTooltipModule],
    exports: [TpMergeTagChipsComponent],
})
export class TpMergeTagChipsModule {}
